import classNames from 'classnames';

import StarIcon from '@heroicons/react/20/solid/StarIcon';
import { ThemeText, ThemeBackground } from '../../../context/theme/ThemeConstantsUpdated';

const { tertiaryBackground } = ThemeBackground;
const { secondaryText } = ThemeText;

export const UserBadge = (props: Props) => {
  const { children, className } = props;

  return (
    <span
      className={classNames(
        tertiaryBackground,
        secondaryText,
        className,
        'inline-flex w-auto cursor-default items-center rounded-full px-2 py-1 text-xs font-medium'
      )}
    >
      {children === 'Official' && <StarIcon className="mr-1 h-3.5 w-3.5" />}
      <span>{children}</span>
    </span>
  );
};

type Props = {
  children: string;
  className?: string;
};
